"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@rradar/core");
var React = require("react");
var RecoverDebtButton = function () {
    var handleClick = function () {
        window.location.href = '/dashboard/debtwizard';
    };
    return (React.createElement(core_1.Button, { buttonType: "primary", onClick: handleClick }, 'Recover New Debt'));
};
exports.default = RecoverDebtButton;
